import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Button from "../../../../components/buttons/button";
import "../../../../styles/pages/postulationState.scss";
import {
  callApi,
  getVideoAndCv,
  saveVideo,
} from "../../../../services/apiService";
import { NotificationManager } from "react-notifications";
import { FormProvider, useForm } from "react-hook-form";
import { AiFillSave } from "react-icons/ai";
import { Grid } from "@mui/material";

const CvPresentationVideo = ({
  postulationId,
  userId,
  openVideoCvModal,
  isBlocked,
}) => {
  const { t } = useTranslation();

  const validations = {
    video_url: {
      required: { value: true, message: t("validationError.videoUrl.require") },
    },
  };
  const defaultValues = {};
  const methods = useForm({ defaultValues });
  const {
    setValue,
    register,
    handleSubmit,
    formState: { errors },
  } = methods;

  useEffect(() => {
    if (!openVideoCvModal || !postulationId) {
      cleanData();
      return;
    }
    const dataToGet = {
      userId: parseInt(userId),
      postulationId: postulationId,
    };
    callApi(
      () => getVideoAndCv(dataToGet),
      (data) => {
        loadData(data);
      }
    );
  }, [openVideoCvModal, postulationId]);

  const loadData = (obj) => {
    setValue("video_url", !obj || !obj.video ? "" : obj.video);
  };
  const cleanData = () => {
    setValue("video_url", "");
  };

  const onSubmitVideo = handleSubmit((data) => {
    const dataToSend = {
      userId: userId,
      videoUrl: data.video_url,
      postulationId: postulationId,
    };
    callApi(
      () => saveVideo(dataToSend),
      (data) => {
        NotificationManager.success(t("form.success"));
      }
    );
  });

  return (
    <>
      <FormProvider {...methods}>
        <form>
          <div>
            <h4>{t("cv.presentation")}</h4>
          </div>
          <div>
            <Grid
              container
              spacing={2}
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={12} md={4}>
                <label>{t("register.video_url")}</label>
              </Grid>
              <Grid item xs={9} md={6}>
                <input
                  placeholder={t("placeholder.video_url")}
                  className="form-control"
                  name="video_url"
                  disabled={isBlocked}
                  {...register("video_url", validations.video_url)}
                />
                {errors.video_url && (
                  <p className="text-danger mt-1">{errors.video_url.message}</p>
                )}
              </Grid>
              {!isBlocked && (
                <Grid item xs={3} md={2}>
                  <Button label={<AiFillSave />} onClick={onSubmitVideo} />
                </Grid>
              )}
            </Grid>
          </div>
        </form>
      </FormProvider>
    </>
  );
};

export default CvPresentationVideo;
